export default {
  create_title: 'Nova conta de API de Parceiro',
  edit_title: 'Editar conta',
  form: {
    name: 'Nome da conta',
    name_placeholder: 'ex.: Integração POS Acme',
    contact_email: 'Email de contacto',
    scope: 'Acesso a restaurantes',
    companies: 'Restaurantes',
    scope_selected: 'Restaurantes selecionados',
    scope_all: 'Todos os restaurantes',
    scope_all_help:
      'As chaves desta conta acedem a todos os restaurantes da sua organização, incluindo os registados mais tarde.',
    companies_placeholder: 'Selecionar restaurantes',
    companies_help: 'As chaves emitidas nesta conta só podem ler e escrever nestes restaurantes.',
    is_active: 'Ativo',
    is_active_help: 'As contas inativas são rejeitadas na autenticação.',
  },
  buttons: {
    cancel: 'Cancelar',
    save: 'Guardar',
    create: 'Criar',
  },
  toasts: {
    created: 'Conta de API de Parceiro criada.',
    updated: 'Conta atualizada.',
    error: 'Não foi possível guardar a conta.',
  },
};
